<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.hcps' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.hcps' | translate}}</h1>
  </div>
</div>

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchTitle' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-2">
          <input type="text"
                 name="searchText"
                 [(ngModel)]="search.searchText"
                 placeholder="{{'app.SearchText' |translate}}"
                 #name="ngModel"
                 (keydown.enter)="onSearch()"
                 class="form-control" />
          <span>Type HCP Arabic Name, English Name, ID, Phone or Email then press enter</span>
        </div>
        <div class="col-sm-2">
          <span class="ui-fluid">
            <p-multiSelect [options]="specialities"
                        (onChange)="onSearch()"
                        styleClass="wid100"
                        defaultLabel="{{'pageHeader.speciality' | translate}}"
                        emptyFilterMessage="No results found"
                        [(ngModel)]="selectedSpecialities"
                        [filter]="true" optionLabel="name"></p-multiSelect>

          </span>
        </div>
        <div class="col-sm-2 margin-top-10 cursor-pointer" (click)="newHCO()" *ngIf="createHcp">
          <span class="margin-right-7 create-new-span">Create New Hcp</span>
          <i class="fa fa-plus-circle"></i>
        </div>
        <div class="col-sm-2 cursor-pointer margin-top-10" (click)="showHcpHcoProvisionModal()" *ngIf="provisionHcp">
          <span class="margin-right-7 create-new-span">{{'app.provision' | translate}} Hcos</span>
          <i class="fa fa-upload" aria-hidden="true"></i>
        </div>
        <div class="col-sm-2 margin-top-10 cursor-pointer" (click)="getMyHcps()">
          <span class="margin-right-7 filter-span">{{'My Hcps' | translate}}</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
        <div class="col-sm-2 margin-top-10 cursor-pointer" (click)="addToMyList()">
          <span class="margin-right-7 filter-span">{{'Add To My List' | translate}}</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-add-hcp *ngIf="addNew" (closeEvent)="closeAdding($event)" (showProvision)="showProvisionModal($event)" [hcpId]="selectedHcpId"  [editFromList]="false"></crm-add-hcp>
<div class="modal fade" bsModal #classesModal="bs-modal" [config]="{backdrop: 'static'}" (onHidden)="onClassesModalHidden()" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'hco.hcoBusinessUnitClasses' | translate}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="classesModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <crm-hcp-brand-class *ngIf="brandMode" (closeEvent)="closeClasses($event)" [hcpId]="selectedHcpId"> </crm-hcp-brand-class>
    </div>
  </div>
</div>
<crm-merge-hcp *ngIf="mergeMode" (closeEvent)="closeMerging($event)" [hcpId]="selectedHcpId"> </crm-merge-hcp>
<crm-hcp-attachements *ngIf="attachementView" (closeEvent)="closeAdding($event)" [hcpId]="selectedHcpId"> </crm-hcp-attachements>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">

          <p-table #dt [value]="hcps" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize" [totalRecords]="totalItems"
                   [lazy]="true" (onLazyLoad)="pageChanged($event)">
            <ng-template pTemplate="header">
              <tr>
                <!--<th width="5%">#</th>-->
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" width={{col.width}} style="text-align:center" class="table-edit">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th width="7%" style="text-align:center" class="table-edit" *ngIf="editHcoHcp">{{'hcps.editHCOs' | translate}}</th>
                <th width="7%" style="text-align:center" class="table-edit">{{'hcps.viewHCOs' | translate}}</th>
                <th width="7%" style="text-align:center" class="table-edit">View</th>
                <th width="7%" style="text-align:center" class="table-edit" *ngIf="attachementsHcps">Attachements</th>
                <th width="7%" style="text-align:center" class="table-edit" *ngIf="editHcpBrands">Classes</th>
                <th width="5%" style="text-align:center" class="table-edit" *ngIf="editHcp">{{'app.edit' | translate}}</th>
                <th width="7%" style="text-align:center" class="table-edit" *ngIf="mergeHcps" title="Merge HCP into another existing HCP">Merge</th>
                <th width="5%" style="text-align:center" class="table-edit" *ngIf="deleteHcp">{{'app.delete' | translate}}</th>
                <th width="5%" style="text-align:center" class="table-edit">{{'hcps.generateOTPCode' | translate}} </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-hcp>
              <tr *ngIf="hcps.length>0 && displayMode==2">
                <!--<td>
    <strong>{{hcp.id}}</strong>
  </td>-->
                <td>{{ hcp.id }}</td>
                <td>{{ hcp.trimmedName }}</td>
                <td *ngIf="showEnglishName">{{ hcp.englishName }}</td>
                <td>{{ hcp.specialityName }}</td>
                <td>{{ hcp.trimmedEmail }}</td>
                <td>{{ hcp.phone }}</td>
                <td *ngIf="editHcoHcp"> <a class="" href="javascript:;" (click)="gotoManageHcpHcos(hcp.id,false)"><i class="fa fa-user-circle-o fa-lg font-size-20"></i></a></td>
                <td> <a class="" href="javascript:;" (click)="gotoManageHcpHcos(hcp.id,true)"><i class="fa fa-user-circle-o fa-lg font-size-20"></i></a></td>
                <td>
                  <a class="" href="javascript:;" (click)="gotoView(hcp)"><i class="fa fa-info-circle  fa-lg font-size-20"></i></a>
                </td>
                <td *ngIf="attachementsHcps">
                  <a class="" href="javascript:;" (click)="gotoAttachements(hcp.id)"><i class="fa fa-file  fa-lg font-size-20"></i></a>
                </td>
                <td *ngIf="editHcpBrands">
                  <a class="" href="javascript:;" (click)="gotoBrands(hcp.id)">
                    <i class="fa fa-user-circle-o fa-lg font-size-20"></i>
                  </a>
                </td>
                <td *ngIf="editHcp">
                  <a class="" href="javascript:;" (click)="gotoEdit(hcp.id)"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
                <td *ngIf="mergeHcps">
                  <a class="" href="javascript:;" (click)="gotoMerge(hcp.id)"><i class="fa fa-plus-square fa-lg font-size-20"></i></a>
                </td>
                <td *ngIf="deleteHcp"><a href="javascript:;" (click)="confirmDelete(hcp.id)"><i class="fa fa-trash-o  fa-lg font-size-20"></i></a></td>
                <td><a href="javascript:;" (click)="generateOTP(hcp.id)"><i class="fa fa-plus-circle  fa-lg font-size-20"></i></a></td>
              </tr>
              <tr *ngIf="hcps.length==0 && displayMode==2">
                <td colspan="5">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="5">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="displayMode==3">
                <td colspan="5">
                  <div class="alert alert-danger alert-dark">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{'app.ServerError' |translate}}.
                  </div>
                </td>

              </tr>
            </ng-template>
          </p-table>

        </div>

      </div>
    </div>
  </div>
</div>

<div class="row">
 
  <div class="col-sm-3 cursor-pointer left-23" *ngIf="mergeHcps" (click)="showProvisionMergeModal()">
    <span class="margin-right-7 edit-profile-span">{{'app.provision' | translate}} {{'hco.mergeSheet' | translate}} </span>
    <i class="fa fa-upload" aria-hidden="true"></i>
  </div>
  <div class="col-sm-3 cursor-pointer left-19" *ngIf="updateSheetHcp" (click)="showProvisionUpdateModal()">
    <span class="margin-right-7 edit-profile-span">{{'hco.updateSheet' | translate}} </span>
    <i class="fa fa-upload" aria-hidden="true"></i>
  </div>
  <div class="col-sm-3 cursor-pointer left-15" (click)="downloadLinkedHcosCSV()" *ngIf="exportHcoHcps">
    <span class="margin-right-7 edit-profile-span">{{'hcps.linkedHcos' | translate}}</span>
    <i class="fa fa-download" aria-hidden="true"></i>
  </div>
  <div class="col-sm-3 cursor-pointer left-7" (click)="downloadCSV()" *ngIf="exportHcps">
    <span class="margin-right-7 edit-profile-span">{{'hcps.excel' | translate}}</span>
    <i class="fa fa-download" aria-hidden="true"></i>
  </div>
</div>


<div class="modal fade" bsModal #deleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'app.deleteMsgConfirmation' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideDeleteModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="deleteHCP()">{{'app.delete' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="modal-sizes-1" bsModal #provisionModal="bs-modal" (onHidden)="onProvisionModalHidden()" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog  modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'hcps.uploadHcpResult' | translate}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="provisionModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <ul id="uidemo-tabs-default-demo" class="nav nav-tabs">
        <li class="active" *ngIf="!provisionUpdate">
          <a href="#uidemo-tabs-default-demo-home" data-toggle="tab">{{'app.downloadTemplate' |translate}}</a>
        </li>
        <li class="" *ngIf="!provisionUpdate">
          <a href="#uidemo-tabs-default-demo-profile" data-toggle="tab">{{'app.uploadTemplate' |translate}}</a>
        </li>
        <li class="active" *ngIf="provisionUpdate">
          <a href="#uidemo-tabs-default-demo-profile" data-toggle="tab">{{'app.uploadTemplate' |translate}}</a>
        </li>
      </ul>

      <div class="tab-content tab-content-bordered">
        <div class="tab-pane fade active in" id="uidemo-tabs-default-demo-home" *ngIf="!provisionUpdate">
          <div class="image-upload cursor-pointer margin-top-5 margin-left-44" (click)="downloadCSVTemplate()">
            <label for="file-download">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
              <i class="fa fa-arrow-down" aria-hidden="true"></i>
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </label>
          </div>

        </div>
        <div class="tab-pane fade" id="uidemo-tabs-default-demo-profile" *ngIf="!provisionUpdate">

          <div class="image-upload cursor-pointer margin-top-5 margin-left-44">
            <label for="file-upload">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
              <i class="fa fa-arrow-up" aria-hidden="true"></i>
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </label>

            <input id="file-upload" #file type="file" (change)="upload(file.files)" />
          </div>
          <br />

          <span style="font-weight:bold;color:blue;" *ngIf="message&&loading">
            {{message}}
          </span>

          <span style="font-weight:bold;color:red;" *ngIf="message&&error&&!loading">
            {{message}}
          </span>

          <span style="font-weight:bold;color:green;" *ngIf="message&&!error&&!loading">
            {{message}}
          </span>



        </div>

        <div class="tab-pane fade active in" id="uidemo-tabs-default-demo-profile" *ngIf="provisionUpdate">

          <div class="image-upload cursor-pointer margin-top-5 margin-left-44">
            <label for="file-update">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
              <i class="fa fa-arrow-up" aria-hidden="true"></i>
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </label>

            <input id="file-update" #file type="file" (change)="upload(file.files)" />
          </div>

          <br />
          <span style="font-weight:bold;color:blue;" *ngIf="message&&loading">
            {{message}}
          </span>

          <span style="font-weight:bold;color:red;" *ngIf="message&&error&&!loading">
            {{message}}
          </span>

          <span style="font-weight:bold;color:green;" *ngIf="message&&!error&&!loading">
            {{message}}
          </span>


        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modal-sizes-1" bsModal #addHcoHcpModal="bs-modal" (onHidden)="onCloseAddHcoHcpModal()" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'HCOs' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">
        <crm-add-hco-hcp *ngIf="showHcoHcp" [hcpId]="selectedHcpId" [viewOnly]="viewOnly" (closeModalEvent)="onCloseAddHcoHcpModal()"></crm-add-hco-hcp>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modal-sizes-1" bsModal #hcpHcoProvisionModal="bs-modal" (onHidden)="onHcpHcoProvisionModalHidden()" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog  modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'Upload Hcp Hcos Result' | translate}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="hcpHcoProvisionModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <crm-provision-hcp-hco #hcpHcoProvisionCSV></crm-provision-hcp-hco>
    </div>
  </div>
</div>


<div class="modal fade" bsModal #hcpDetailsModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg" style="width:95% !important;margin-top:3% !important;margin-left:3% !important;">
    <div class="panel padding-2">
      <div class="row">
        <h1 class="filter-title col-sm-10">{{'HCP Details' | translate}}</h1>
        <!--<h1 class="filter-title col-sm-2"> 0% </h1>-->
        <div ccol-sm-2>
          <div style="display: flex; align-items: center; justify-content: center;">
            <div style="display: inline-flex; flex-direction: column; align-items: center; margin-right: 10px;">
              <span>ROI</span>
              <span>Net Sales</span>
              <span style="border-top: 1px solid black; width: 90px; margin: 4px 0;"></span>
              <span>Net Spending</span>
            </div>
            <div>= 215%</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group has-feedback">
          <label class="control-label col-md-3" for="userName">{{'Id' | translate}}</label>
          <div class="col-md-9">
            <p class="form-control-static" style="font-weight:bold">{{selectedHcp.id}}</p>
          </div>
        </div>
        <div class="form-group has-feedback">
          <label class="control-label col-md-3" for="userName">{{'app.name' | translate}}</label>
          <div class="col-md-9">
            <p class="form-control-static" style="font-weight:bold">{{selectedHcp.fullName}}</p>
          </div>
        </div>
        <div class="form-group has-feedback">
          <label class="control-label col-md-3" for="userName">{{'Specialty' | translate}}</label>
          <div class="col-md-9">
            <p class="form-control-static" style="font-weight:bold">{{selectedHcp.specialityName}}</p>
          </div>
        </div>
        <div class="form-group has-feedback">
          <label class="control-label col-md-3" for="userName">{{'Email' | translate}}</label>
          <div class="col-md-9">
            <p class="form-control-static" style="font-weight:bold">{{selectedHcp.email}}</p>
          </div>
        </div>
        <div class="form-group has-feedback">
          <label class="control-label col-md-3" for="userName">{{'Consent Status' | translate}}</label>
          <div class="col-md-9">
            <p class="form-control-static" style="font-weight:bold">{{selectedHcp.consentStatus}}</p>
          </div>
        </div>
        <div class="form-group has-feedback">
          <label class="control-label col-md-3" for="userName">{{'Golden Lis' | translate}}</label>
          <div class="col-md-9">
            <p class="form-control-static" style="font-weight:bold">{{selectedHcp.goldenList}}</p>
          </div>
        </div>
        <div class="form-group has-feedback">
          <label class="control-label col-md-3" for="userName">{{'HCP classification' | translate}}</label>
          <div class="col-md-9">
            <p class="form-control-static" style="font-weight:bold">{{selectedHcp.hcpClassName}}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div>
            <h1 class="filter-title">{{'Hcos' | translate}}</h1>
          </div>
          <div class="panel-body" style="height: 230px" slimScroll>
            <p-table [value]="hcpHcos" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'Hco Id' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Hco Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Hco Class Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Hco Brick Name' | translate}}
                  </th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rep>
                <tr *ngIf="hcpHcos.length>0">
                  <td>{{rep.hcoId}}</td>
                  <td>{{rep.hcoName}}</td>
                  <td>{{rep.hcoClassName}}</td>
                  <td>{{rep.hcoBrickName}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-sm-4">
          <label class="control-label">{{'visits.dateFrom' | translate}} </label>
          <div class="input-group date">
            <input type="text"
                   class="form-control"
                   name="startDatePickersea"
                   #startDatePickersea="ngModel"
                   [(ngModel)]="dateFrom"
                   required="required"
                   placeholder="yyyy-mm-dd"
                   #d4="bsDatepicker"
                   bsDatepicker
                   autocomplete="off" (bsValueChange)='onDateFromChanged($event)'
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }">
            <span class="input-group-btn date-label">
              <button class="btn date-btn" (click)="d4.toggle()" type="button"><i class="fa fa-calendar"></i></button>
            </span>

          </div>

          <!--<span>{{"Select your search date and press enter or click search" |translate }}</span>-->
        </div>
        <div class="col-sm-4">
          v
          at
          <label class="control-label">{{'visits.dateTo' | translate}} </label>
          <div class="input-group date">
            <input type="text"
                   class="form-control"
                   name="endDatePickersea"
                   #endDatePicker="ngModel"
                   [(ngModel)]="dateTo"
                   required="required"
                   #d5="bsDatepicker"
                   placeholder="yyyy-mm-dd" (bsValueChange)='onDateToChanged($event)'
                   bsDatepicker
                   autocomplete="off"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD'}">

            <span class="input-group-btn date-label">
              <button class="btn date-btn" (click)="d5.toggle()" type="button">
                <i class="fa fa-calendar"></i>
              </button>
            </span>
          </div>
        </div>
        <!--<div class="col-sm-4 margin-top-10 cursor-pointer" (click)="getHcpDetails()">
          <span class="margin-right-7 filter-span">{{'app.search' | translate}}</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>-->
      </div>


      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">
        <div class="col-sm-6">
          <div>
            <h1 class="filter-title">{{'Visits' | translate}} ({{hcpVisits?.length}}/{{hcpVisitsTotlaCount}})</h1>
          </div>
          <div class="panel-body" style="height: 230px" slimScroll>
            <p-table [value]="hcpVisits" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'Hco Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Date' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Hco Org Type' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Hco Speciality' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Hco Brick' | translate}}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rep>
                <tr *ngIf="hcpVisits.length>0">
                  <td>{{rep.hcoName}}</td>
                  <td> {{rep.date |date }}</td>
                  <td>{{rep.organizationTypeName}}</td>
                  <td>{{rep.specialityName}}</td>
                  <td>{{rep.brickName}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="col-sm-6">
          <div>
            <h1 class="filter-title">{{'Events' | translate}} ({{hcpActivities?.length}}/{{hcpActivitiesTotlaCount}})</h1>
          </div>
          <div class="panel-body" style="height: 230px" slimScroll>
            <p-table [value]="hcpActivities" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'repActivities.title' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'repActivities.startDate' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'repActivities.endDate' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Actual Cost' | translate}}
                  </th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rep>
                <tr *ngIf="hcpActivities.length>0">
                  <td>   {{rep.title}}   </td>
                  <td>{{rep.startDate |date }}</td>
                  <td> {{rep.endDate |date }}</td>
                  <td>   {{rep.actualCost}}   </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="col-sm-6">
          <div>
            <h1 class="filter-title">{{'Service Requests' | translate}} ({{hcpServiceRequests?.length}}/{{hcpServiceRequestsTotlaCount}})</h1>
          </div>
          <div class="panel-body" style="height: 230px" slimScroll>
            <p-table [value]="hcpServiceRequests" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'repActivities.title' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'repActivities.startDate' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'repActivities.endDate' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Actual Cost' | translate}}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rep>
                <tr *ngIf="hcpActivities.length>0">
                  <td>   {{rep.title}}   </td>
                  <td>{{rep.startDate |date }}</td>
                  <td> {{rep.endDate |date }}</td>
                  <td>   {{rep.actualCost}}   </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="col-sm-6">
          <div>
            <h1 class="filter-title">{{'Pharmacies' | translate}}</h1>
          </div>
          <div class="panel-body" style="height: 230px" slimScroll>
            <p-table [value]="hcpPharmaciess" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'Pharmacy Id' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Pharmacy Name' | translate}}
                  </th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rep>
                <tr *ngIf="hcpPharmaciess.length>0">
                  <td>{{rep.pharmacyId}}</td>
                  <td>{{rep.pharmacyName}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="col-sm-6">
          <div>
            <h1 class="filter-title">{{'Stores' | translate}}</h1>
          </div>
          <div class="panel-body" style="height: 230px" slimScroll>
            <p-table [value]="hcpStores" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'Store Id' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Store Name' | translate}}
                  </th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rep>
                <tr *ngIf="hcpStores.length>0">
                  <td>{{rep.hcoId}}</td>
                  <td>{{rep.hcoName}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>


        <div class="col-sm-6">
          <div>
            <h1 class="filter-title">{{'Agreements' | translate}} ({{hcpAgreements?.length}}/{{hcpAgreementsTotlaCount}})</h1>
          </div>
          <div class="panel-body" style="height: 230px" slimScroll>
            <p-table [value]="hcpAgreements" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'User Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'HCP Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Item Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Brand Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Date' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Target Quantity' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Target Value' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Actual Quantity' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Actual Value' | translate}}
                  </th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rep>
                <tr *ngIf="hcpAgreements.length>0">
                  <td>{{rep.createdByName}}</td>
                  <td>{{rep.hcpName}}</td>
                  <td>{{rep.itemName}}</td>
                  <td>{{rep.itemBrandName}}</td>
                  <td>{{rep.agreementDate | date}}</td>
                  <td>{{rep.targetQuantity}}</td>
                  <td>{{rep.targetValue}}</td>
                  <td>0</td>
                  <td>0</td>

                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="col-sm-6">
          <div>
            <h1 class="filter-title">{{'Giveaways' | translate}}</h1>
          </div>
          <div class="panel-body" style="height: 230px" slimScroll>
            <p-table [value]="hcpGiveaways" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Type' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Quantity' | translate}}
                  </th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rep>
                <tr *ngIf="hcpGiveaways.length>0">
                  <td>{{rep.giveawayItemName}}</td>
                  <td>{{rep.giveawayTypeName}}</td>
                  <td>{{rep.quantity}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>



      <div class="panel-footer margin-left-30 margin-top-20">
        <button type="button" (click)="hcpDetailsModal.hide()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
      </div>
    </div>


  </div>
</div>

<div class="modal fade" bsModal #myHcpModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div class="row">
        <h1 class="filter-title col-sm-10">{{'My HCPs' | translate}}</h1>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel-body">
            <p-table [value]="myHcps" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th class="table-edit">
                    {{'Id' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Name' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Speciality' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Email' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Phone' | translate}}
                  </th>
                  <th class="table-edit">
                    {{'Visits' | translate}}
                  </th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-hcp>
                <tr *ngIf="myHcps.length>0">
                  <td>{{hcp.id}}</td>
                  <td>{{hcp.fullName}}</td>
                  <td>{{hcp.specialityName}}</td>
                  <td>{{hcp.email}}</td>
                  <td>{{hcp.phone}}</td>
                  <td> <a class="" href="javascript:;" (click)="gotoCreatVisit(hcp.id)"><i class="fa fa-telegram fa-lg font-size-20"></i></a></td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>

      <div class="panel-footer margin-left-30 margin-top-20">
        <button type="button" (click)="myHcpModal.hide()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
      </div>
    </div>


  </div>
</div>

<div class="modal fade" id="modal-sizes-1" bsModal #provisionMergeModal="bs-modal" (onHidden)="onProvisionMergeModalHidden()" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog  modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'Merge HCP' | translate}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="provisionMergeModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <crm-provision-merge-hcp #provisionMergeCSV></crm-provision-merge-hcp>
    </div>
  </div>
</div>
